import React, { useContext } from 'react'

import { BuilderContext } from '../../../Sandbox/components/store/store.Builder'
import { ViewFormContext } from '../../../ViewForm/components/store/store.ViewForm'
import { AnswersContext } from '../store/store.Answers'
import styles from './TopTitle.module.css'
import { Box, Button, TablePagination, IconButton } from '@mui/material'

import { Tooltip } from 'antd'

import { LeftOutlined, DownloadOutlined, SyncOutlined } from '@ant-design/icons'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'

import { observer } from 'mobx-react-lite'

const TopTitle = observer(() => {
  const answersStore = useContext(AnswersContext)
  const builderContext = useContext(BuilderContext)

  return (
    <div className={styles.panel_main_title}>
      <div className={styles.buttons}>
        <a href={`/sandbox/${builderContext.url_code}/`}>
          <Tooltip title="Aller au Builder">
            <Button className={styles.exporter_btn}>
              <KeyboardArrowLeftIcon className={styles.exporter_btn_icon} />
              <div className={styles.exporter_btn_text}>Builder</div>
            </Button>
          </Tooltip>
        </a>
      </div>

      <div className={styles.title_container}>
        <div className={styles.title}>
          <h1>Réponses pour : {builderContext.styleForm.title_form}</h1>
        </div>
        <div className={styles.created_by}>
          <p>
            Créé par :{' '}
            {`${builderContext.styleForm.created_by.first_name} ${builderContext.styleForm.created_by.last_name}`}
          </p>
        </div>
      </div>
    </div>
  )
})

export default TopTitle
